import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imovel-outras-entidades',
  templateUrl: './imovel-outras-entidades.component.html',
  styleUrls: ['./imovel-outras-entidades.component.scss']
})
export class ImovelOutrasEntidadesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
